module.exports = __webpack_public_path__ + "static/media/stMATIC.9b5dee2d.png";